export default __webpack_public_path__ + "static/media/CardArrow.f19521ae.svg";